import type { InputHTMLAttributes, TextareaHTMLAttributes, HTMLAttributes } from 'react'
import { forwardRef } from 'react'
import { classNames } from '@/ui/utils/main'

const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, fwdRef) => {
    return (
      <input
        type={type}
        className={classNames(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={fwdRef}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, fwdRef) => {
    return (
      <textarea
        className={classNames(
          'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={fwdRef}
        {...props}
      />
    )
  },
)
Textarea.displayName = 'Textarea'

const Label = forwardRef<HTMLLabelElement, HTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, fwdRef) => {
    return (
      <label
        ref={fwdRef}
        className={classNames(
          'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
          className,
        )}
        {...props}
      />
    )
  },
)
Label.displayName = 'Label'

export { Input, Textarea, Label }
